import React from 'react';

import Accordion from 'react-bootstrap/Accordion';

class UserItem extends React.Component {
    render() {
	var user = this.props.user;
	var email = "mailto:" + user.email;
	
	return (
	    <Accordion.Item eventKey={user.id}>
		<Accordion.Header>{user.firstname} {user.lastname} &nbsp;&nbsp; <i>{user.team}</i></Accordion.Header>
		<Accordion.Body>
		    <table>
			<tbody>
			    <tr>
				<td align="right"><b>Scoutk&aring;r:</b></td>
				<td>{user.troop}</td>
			    </tr>
			    <tr>
				<td align="right"><b>Email:</b></td>
				<td><a href={email}>{user.email}</a></td>
			    </tr>
			    <tr>
				<td align="right"><b>Kurs&aring;r:</b></td>
				<td>{user.year}</td>
			    </tr>
			</tbody>
		    </table>
		</Accordion.Body>
	    </Accordion.Item>
	);
    }
}

export default UserItem;
